var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settlement-box"},[_c('Table',{attrs:{"loading":_vm.loading,"border":"","columns":_vm.tableColumns,"no-data-text":_vm.noDataText,"data":_vm.tableData,"max-height":_vm.tableHeight + 10},on:{"on-selection-change":_vm.onSelectionChange},scopedSlots:_vm._u([{key:"orgName",fn:function(ref){
var row = ref.row;
return [_c('TablePoptip',{attrs:{"content":row.orgName}})]}},{key:"schoolName",fn:function(ref){
var row = ref.row;
return [_c('TablePoptip',{attrs:{"content":row.schoolName}})]}},{key:"approvalSts",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm._f("initApprovalSts")(row.approvalSts)))])]}},{key:"settleSts",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm._f("initSettleSts")(row.settleSts)))])]}},{key:"bankId",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm._f("initBankId")(row.bankId)))])]}},{key:"settleCycle",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm._f("initSettleCycle")(row.settleCycle)))])]}},{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',{staticClass:"click-btn-430",staticStyle:{"margin-right":"5px"},on:{"click":function($event){return _vm.handleToDetails(row, index)}}},[_vm._v("查看详情")]),(_vm.showAdminCfmBtn(row))?_c('span',{staticClass:"click-btn-430",on:{"click":function($event){return _vm.handleAdminCfm(row, index)}}},[_vm._v("提交运营确认")]):_vm._e()]}}])}),_c('AdminCheck',{ref:"adminCheckRef",on:{"on-uploadStaSts":_vm.onUploadStaSts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }